<template>
  <div class="dict-value-editor" :class="innerScroll && 'inner-scroll'" ref="dictEditorContentRef">
    <el-table :data="dictClassifyValue">
      <el-table-column prop="labelName" label="分类名称" width="180">
        <template slot-scope="{ row }">
          <el-input
            v-if="couldEdit"
            :value="row.labelName"
            placeholder="请输入分类名称"
            @input="val => changeInput(row, 'labelName', val)"
          />
          <span v-else>{{ row.labelName }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="children" label="近义词">
        <template slot-scope="{ row }">
          <el-input
            v-if="couldEdit"
            :value="row.children"
            placeholder="请输入分类近义词"
            @input="val => changeInput(row, 'children', val)"
          />
          <span v-else>{{ row.children }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" v-if="couldEdit" width="100">
        <template slot-scope="{ row }">
          <el-button type="text" @click="delHandle(row)">
            <span>删除</span>
          </el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    couldEdit: {
      type: Boolean,
      default: false
    },
    dictClassifyValue: {
      type: Array,
      default: () => []
    },
    innerScroll: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    delHandle(row) {
      this.$emit('del', row);
    },
    changeInput(row, key, val) {
      row[key] = val.replace(/[ \n\r\t]/g, '');
    },
    scrollBottomHandle() {
      this.$refs.dictEditorContentRef.scrollTop = this.$refs.dictEditorContentRef.childNodes[0].clientHeight;
    }
  }
};
</script>

<style lang="scss" scoped>
.dict-value-editor {
  border: 1px solid #ebeef5;
  border-bottom: 0;

  &.inner-scroll {
    max-height: 300px;
    overflow: auto;
  }
}
</style>
